import { StatusDTO } from './api/useIntegrationsSettingsQuery';
import { BlackDiamond } from './components/BlackDiamond/BlackDiamond';
import { Blueleaf } from './components/Blueleaf/Blueleaf';
import { CharlesSchwab } from './components/CharlesSchwab/CharlesSchwab';
import { IFP } from './components/IFP/IFP';
import { Redtail } from './components/Redtail/Redtail';
import { Riskalyze } from './components/Riskalyze/Riskalyze';
import { TDAmeritrade } from './components/TDAmeritrade/TDAmeritrade';
import { TDVeoOne } from './components/TDVeoOne/TDVeoOne';
import { Wealthbox } from './components/Wealthbox/Wealthbox';

export const STATUS_MAP = {
  [StatusDTO.Success]: { label: 'Connected', icon: 'fa-check', color: 'success.500' },
  [StatusDTO.Broken]: { label: 'Link Broken', icon: 'fas fa-unlink', color: 'error.500' },
  [StatusDTO.IsDownloading]: { label: 'Downloading', icon: 'fa fa-download', color: 'primary.500' },
};

export const INTEGRATION_MODAL_COMPONENTS_MAP = {
  BlackDiamond,
  Blueleaf,
  CharlesSchwab,
  IFP,
  Redtail,
  Riskalyze,
  TDAmeritrade,
  TDVeoOne,
  Wealthbox,
};
